import React, { Fragment } from 'react'
import AEADisasterCategoriesList from './AEADisasterCategoriesList'

const AEADisasterCategories = () => {
    return (
        <Fragment>
            <div className="m-sm-30">
                <h3 className="m-0 mb-6">Liste des catégories de sinistres</h3>
                <AEADisasterCategoriesList />
            </div>
        </Fragment>
    )
}

export default AEADisasterCategories
